/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Card, Checkbox, Label, TextInput } from "flowbite-react";
import { type FC, useState } from "react";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const SignUpPage: FC = function () {
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation("auth");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center px-6 lg:h-screen lg:gap-y-12">
      <a href="/" className=" flex items-center gap-x-1 lg:my-0">
        <img
          alt="ICONT"
          src="/images/icont.png"
          className="mr-3 h-10"
        />
       
      </a>
      <Card
        horizontal
        imgSrc="images/signup.png"
        imgAlt="ICONT"
        className="w-full md:max-w-[1024px] md:[&>*]:w-full md:[&>*]:p-16 [&>img]:hidden md:[&>img]:w-96 md:[&>img]:p-0 lg:[&>img]:block"
      >
        <h1 className="mb-3 text-2xl font-bold dark:text-white md:text-3xl">
          {t("signup.title")}
        </h1>
        <form>
          <div className="mb-4 flex flex-col gap-y-3">
            <Label>{tCommon("form.userName")}</Label>
            <TextInput
              id="text"
              name="username"
              placeholder={tCommon("form.userNamePlaceholder")}
              type="text"
            />
          </div>
          <div className="mb-6 flex flex-col gap-y-3">
            <Label htmlFor="password">{tCommon("form.password")}</Label>
            <div className="relative">
              <TextInput
                id="password"
                name="password"
                placeholder="••••••••"
                type={showPassword ? "text" : "password"}
              />
              <button
                type="button"
                className="absolute right-3 top-2.5 text-gray-500 dark:text-gray-400"
                onClick={() => setShowPassword((prev) => !prev)}
                tabIndex={-1}
              >
                {showPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
              </button>
            </div>
          </div>
          <div className="mb-6 flex flex-col gap-y-3">
            <Label htmlFor="confirmPassword">{tCommon("form.confirmPassword")}</Label>
            <div className="relative">
              <TextInput
                id="confirmPassword"
                name="confirmPassword"
                placeholder="••••••••"
                type={showConfirmPassword ? "text" : "password"}
              />
              <button
                type="button"
                className="absolute right-3 top-2.5 text-gray-500 dark:text-gray-400"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                tabIndex={-1}
              >
                {showConfirmPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
              </button>
            </div>
          </div>
          <div className="mb-6 flex items-center gap-x-3">
            <Checkbox id="acceptTerms" name="acceptTerms" />
            <Label htmlFor="acceptTerms">
              {tCommon("form.accept")}&nbsp;
              <a href="#" className="text-primary-700 dark:text-primary-200">
                {tCommon("form.termsAndConditions")}
              </a>
            </Label>
          </div>
          <div className="mb-7">
            <Button type="submit" className="w-full lg:w-auto bg-gradient-to-br from-purple-600 to-blue-500 text-white hover:bg-gradient-to-bl focus:ring-blue-300 dark:focus:ring-blue-800">
              {t("signup.submitButton")}
            </Button>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-300">
            {t("signup.alreadyRegistered")}&nbsp;
            <a href="/login" className="text-primary-600 dark:text-primary-200">
              {t("signup.loginHere")}
            </a>
          </p>
        </form>
      </Card>
    </div>
  );
};

export default SignUpPage;
